export const LOADING_GLOBAL_KEY = 'global';
